<template>
    <div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px">
                    <col>
                </colgroup>
                <tr v-for="(data,index) in itemData" :key="`item${index}`">
                    <td class="c_t_title">사용한 상품 {{ index + 1 }}</td>
                    <td>
                        <div>
                            <div class="upload_box" v-if="checkData(data.link)">
                                <div class="item_image"
                                     :style="`background-image: url(${data.link}?${setImageOptions(178, 178)})`"></div>
                            </div>
                            <div class="upload_box empty" v-else
                                 @click="$modal.show('lookbook-item-modal',{itemData:itemData , itemIndex :index})">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </div>
                            <div class="use_item_content">
                                <div>
                                    {{ data.title }}
                                    <el-button class="ml10" size="mini" type="info"
                                               @click="deleteItem(data.updateKey,index)">
                                        상품 삭제
                                    </el-button>
                                </div>
                                <div class="pt30">
                                    <el-time-picker
                                            v-model="data.time"
                                            class="el-time-picker"
                                            placeholder="00:00:00"
                                            value-format="HH:mm:ss"
                                            @blur="changeTime()"
                                    >
                                    </el-time-picker>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title" colspan="2">
                        <button style="height: 60px; width: 100%"
                                @click="itemAdd()">+ 상품 추가하기
                        </button>
                    </td>
                </tr>
            </table>

        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";
import imageOption from "@/mixins/imageOption";
import dateMixins from "@/mixins/dateMixins";
import elasticMixins from "@/mixins/elasticMixins";
import {elasticOption} from "@/api/config";

export default {
    name: "LookbookItemComponent",
    mixins: [alertMixins, imageOption, dateMixins, elasticMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        lookbookKey: '',
    },
    data() {
        return {
            itemData: [{
                link: '',
                title: '',
                key: '',
                time: '00:00:00',
            }],
            itemKey: [],
            item: [],
            deleteItems: [],
        }
    },
    created() {
        this.initElastic(elasticOption.index, elasticOption.type)
        this.getList();

    },
    mounted() {
        EventBus.$on('selectLookbookItem', this.selectLookbookItem);
        EventBus.$on('writeLookbookItem', this.writeLookbookItem);
        EventBus.$on('getLookbookItem', this.getList);

    },
    beforeDestroy() {
        EventBus.$off('selectLookbookItem');
        EventBus.$off('writeLookbookItem');
        EventBus.$off('getLookbookItem');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getList() {
            let params = {
                lid: this.lookbookKey,
                ip: 0,
            }
            this.$api.$lookbook.getLookbookItem(params).then(res => res.Data.Result).then(res => {
                if (res.Info.Type === 1) {
                    if (res.List.length > 0) {
                        this.item = res.List;
                        this.makeItemKey(res.List);
                    }
                } else {
                    this.errorAlert('데이터 통신에 실패하였습니다.')
                    this.$router.back();
                    return
                }
            })
        },
        makeItemKey(list) {
            util.Array.each(list, (data, index, arr) => {
                this.itemKey.push(data.i_idx);
            })
            this.getItemElasticData();
        },

        itemAdd() {
            let item = {
                link: '',
                title: '',
                key: '',
                time: '',
            }
            this.itemData.push(item);
        },
        deleteItem(key, index) {
            if (util.isEmpty(key)) {
                this.itemData.splice(index, 1);
                return
            }
            let itemIndex = this.itemData.findIndex(item => item.updateKey === key);
            if (itemIndex > -1) {
                this.itemData.splice(index, 1);
                this.deleteItems.push(key);
            } else {
                this.itemData.splice(index, 1);
            }
        },
        checkData(data) {
            return !util.isEmpty(data);
        },
        selectLookbookItem(data, index) {
            this.itemData[index] = data;
            this.$forceUpdate();
        },
        changeTime() {
            this.$forceUpdate();
        },
        getItemElasticData() {
            let body = {
                query: {
                    bool: {
                        must: [
                            {terms: {'i_idx': this.itemKey}}
                        ]
                    }
                }
            }
            let elasticData = [];
            this.getAllSearch(body, elasticData).then(standByScrollId => {
                this.runClearScrollId(standByScrollId)
                let itemArrData = []
                util.Array.each(this.item, (data, index, arr) => {
                    let itemIndex = elasticData.findIndex(ed => ed.i_idx === data.i_idx);
                    if (itemIndex > -1) {
                        let itemData = {
                            link: elasticData[itemIndex].itemImage[0].org_url,
                            title: elasticData[itemIndex].i_name,
                            key: elasticData[itemIndex].i_idx,
                            time: '',
                            secTime: data.lbi_time,
                            updateKey: data.lbi_idx,
                        }
                        let hour = parseInt(data.lbi_time / 3600);
                        let min = parseInt((data.lbi_time % 3600) / 60);
                        let sec = data.lbi_time % 60;
                        itemData.time = `${hour}:${min}:${sec}`;
                        itemArrData.push(itemData);
                    }
                })
                itemArrData = this.$_.sortBy(itemArrData, ['secTime']);

                this.itemData = itemArrData;
            })
        },

        makeItem(params) {
            params.items = {}
            params.items.create = [];
            params.items.update = [];
            params.items.delete = [];


            this.itemData.forEach(item => {
                if (!util.isEmpty(item.key)) {
                    let timeArr = item.time.split(":");
                    let secondTime = (Number(timeArr[0]) * 3600) + (Number(timeArr[1]) * 60) + Number(timeArr[2]);

                    if (!util.isEmpty(item.updateKey)) {
                        params.items.update.push({
                            'i_idx': item.key,
                            'lbi_time': Number(secondTime),
                            'lbi_idx': item.updateKey
                        })
                    } else {
                        params.items.create.push({
                            'i_idx': item.key,
                            'lbi_time': Number(secondTime)
                        })
                    }
                }
            })
            if (this.deleteItems.length > 0) {
                this.deleteItems.forEach(item => {
                    params.items.delete.push({"lbi_idx": item})
                })
            }


            if (util.isEmpty(params.items.create)) {
                delete params.items.create
            }
            if (util.isEmpty(params.items.update)) {
                delete params.items.update
            }
            // if (util.isEmpty(params.items.delete)) {
            //     delete params.items.delete
            // }
            return params
        },

        writeLookbookItem() {
            EventBus.$emit('changeLoading', true);
            let params = {l_idx: this.lookbookKey};
            params = this.makeItem(params);
            try {
                this.$api.$lookbook.writeLookbookItem(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('changeLoading', false);
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        this.createAlert({
                            content: '저장되었습니다.',
                            hide: () => {
                                this.getList()
                            }
                        })
                    } else {
                        this.errorAlert(type);
                        this.isRunning = false;
                    }
                })
            } catch (e) {
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
        returnWriteType(type) {
            if (type == 1) {
                return true;
            } else {
                return '아이템 저장에 실패하였습니다.';
            }
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
